// ─── src/data/italyVenues.js ─────────────────────────────────────────────────
import { hydrateScores } from "../engine/index.js";

// Helper: Generate URL-friendly slug from venue name
const makeSlug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const VENUES = [
  // Emptied 2026-07-17. This array held 12 HARDCODED London venue records that
  // rendered on /england with Unsplash STOCK photos and no listing behind them,
  // "curated, never crowdsourced" on the homepage while showing invented cards.
  // 9 are now real DB listings (spencer-house, syon-park, strawberry-hill-house,
  // fulham-palace, eltham-palace, hurlingham-club, the-savoy, one-marylebone, and
  // claridges); Kew Orangery and The Ned are unbuilt and were removed rather than
  // left as fakes; Hampstead Pergola is not listable (expired marriage licence).
  // Region/Country/Location pages now render London purely from the database.
];

// ── REGIONS, delegated to geo.js (single source of truth) ─────────────────
// Re-export backward-compat { name, slug, group } array + lookup helpers
import {
  REGIONS_FLAT as REGIONS,
  getRegionBySlug,
  getRegionNameBySlug,
  getRegionSlugByName,
} from "./geo.js";
export { REGIONS, getRegionBySlug, getRegionNameBySlug, getRegionSlugByName };

export const STYLES  = ["All Styles","Rustic Luxe","Black Tie","Romantic","Garden","Historic","Vineyard","Intimate","Coastal"];
export const CAPS    = ["Any Capacity","Up to 50","51–100","101–200","200+"];
export const PRICES  = ["All Budgets","£££","££££"];

/** Default filter state, exported so CategoryPage and FilterBar share the same reset values */
export const DEFAULT_FILTERS = {
  region:   "all",
  style:    STYLES[0],
  capacity: CAPS[0],
  price:    PRICES[0],
};

// ── Hydrate curated index scores ─────────────────────────────────────────────
hydrateScores(VENUES);
